import React from 'react'
import { Paper } from '@mui/material'
import { red } from '@mui/material/colors'

type TrialOperationControlProps = {
  isMobileOnly?: boolean
}

export const TrialOperationControl = ({isMobileOnly = false}: TrialOperationControlProps) => {
  return (
    <Paper sx={{
      width: isMobileOnly ? 'calc(100dvw - 68px)' : 360,
      maxWidth: 360,
      fontSize: isMobileOnly ? 11 : 14,
      fontWeight: isMobileOnly ? 'normal' : 'bold',
      whiteSpace: 'pre-wrap',
      p: 1,
      backgroundColor: 'rgb(255, 255, 255, 0.9)',
      color: red[700]
    }}>
      {
        '【試験運用中】\n' +
        '浸水していると推定される範囲は過去の検証を元に想定される現在の浸水を推定した結果であり、現実とは異なる可能性があります。\n' +
        '着色されていない地域でも安心しないでください。\n' +
        '10分毎に刻々と変わる情報に注意し、避難行動の参考としてください。'
      }
    </Paper>
  )
}
